export const isShareUrl = () => {
  const pathname = window.location.pathname;
  const searchParams = new URLSearchParams(window.location.search);
  return pathname.includes('/share/') || searchParams.has('shareId');
};

export const isReplayUrl = () => {
  const pathname = window.location.pathname;
  const searchParams = new URLSearchParams(window.location.search);
  return pathname.includes('/replay/') || searchParams.has('replayId');
};
